import React from 'react';

interface CompletedIconProps {
  size?: number;
  className?: string;
}

const CompletedIcon: React.FC<CompletedIconProps> = ({ 
  size = 14, 
  className = '' 
}) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 14 14" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        d="M12.8334 6.99984C12.8334 3.7915 10.2084 1.1665 7.00008 1.1665C3.79175 1.1665 1.16675 3.7915 1.16675 6.99984C1.16675 10.2082 3.79175 12.8332 7.00008 12.8332C10.2084 12.8332 12.8334 10.2082 12.8334 6.99984Z" 
        fill="#14C784"
      />
      <path 
        d="M4.52075 6.99995L6.17159 8.65079L9.47909 5.34912" 
        stroke="#1F1F1F" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CompletedIcon;